import React, {useEffect} from 'react';
import Div from "@jumbo/shared/Div";
import * as yup from "yup";
import {
    Alert,
    Box,
    Button, Checkbox,
    FormControl, FormControlLabel,
    InputLabel, ListItemText,
    MenuItem,
    OutlinedInput, Radio,
    TextField,
    Typography
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import Stack from "@mui/material/Stack";
import {Form, Formik} from "formik";
import commonServices from "../../../../services/common-services";
import adminServices from "../../../../services/admin-services";
import {useTranslation} from "react-i18next";
import Select from "@mui/material/Select";
import {levelsWithPoints, levelsWithPoints1, programFrequency} from "../../../../utils/constants/appActions";
import {useAppMutation} from "../../../../services";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const steps = ['Select campaign settings', 'Create an ad group', 'Create an ad'];
const validationSchema = yup.object({
    email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email is required'),
    password: yup
        .string('Enter your password')
        .required('Password is required'),
});

const valuetext = (value) => {
    return value;
};


const Step4 = ({hideDialog, stepsData, handleNext, setStepsData}) => {

    const [isLoading, setIsLoading] = React.useState(false);
    const [teachers, setTeacher] = React.useState('');
    const [values, setValues] = React.useState({
        receivedHomeWork: '',
        autoTeacherReplacement: '',
        influencer: ''

    });
    const [errMsg, setErrMsg] = React.useState('');
    const {t} = useTranslation();

    const marks = [
        {
            value: 1,
            label: (t('parent-children.title.disagree')),
        },
        {
            value: 10,
            label: (t('parent-children.title.agree')),
        },
    ];


    const {
        mutate: loadTeacher,
        isSuccess: isTSuccess,
        isError: isTError,
        data: tData
    } = useAppMutation(adminServices.loadTeachers);


    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    useEffect(() => {

        if (stepsData) {
            setValues({...values, ...stepsData});
        }

    }, [stepsData])

    const submitStep = async () => {
        setErrMsg('');

        const {receivedHomeWork, autoTeacherReplacement, influencer} = values;


        try {
            setIsLoading(true);
            if (stepsData.newImage) {
                let b = await fetch(stepsData.newImage).then(r => r.blob());
                stepsData.imageBase64 = await commonServices.blobToBase64(b)
            }
            const v = {...stepsData, receivedHomeWork, autoTeacherReplacement, influencer}
            setStepsData(v);
            await adminServices.saveStudent(v);
            handleNext(5);
        } catch (error) {
            setErrMsg(error.message);
            setIsLoading(false);
        }


    };

    const handleLevelChange = (e) => {
        const selectedLabel = e.target.value;
        const selectedLevel = levelsWithPoints1.find((level) => level.label === selectedLabel);

        console.log("Selected Level:", selectedLevel); // Log the selected level

        if (selectedLevel) {
            console.log("Min Points:", selectedLevel.points); // Log minPoints (selectedLevel points)
            console.log("Max Points:", selectedLevel.maxPoints); // Log maxPoints

            setValues((prevValues) => ({
                ...prevValues,
                actualLevel2: {
                    label: selectedLevel.label,
                    points: selectedLevel.points,
                }, // Correctly updating actualLevel2
                noOfPoints: '', // Reset points when changing the level
                error: '', // Clear any previous errors
                minPoints: selectedLevel.points, // Set the minimum points for the selected level
                maxPoints: selectedLevel.maxPoints, // Set the maxPoints based on the selected level
                helperText: `Enter points between ${selectedLevel.points} and ${selectedLevel.maxPoints}`, // Set the helper text for guidance
            }));
        } else {
            console.log("Level not found");
        }
    };

    const handleNoOfPointsChange = (e) => {
        const input = e.target.value;
        // Ensure the input contains only numbers by removing any non-digit characters.
        const onlyNumbers = input.replace(/\D/g, '');

        // Check if the input number is within the valid range of minPoints and maxPoints
        const isValid = onlyNumbers >= values.minPoints && onlyNumbers <= values.maxPoints;

        // Update the state with the cleaned input directly.
        setValues((prevValues) => ({
            ...prevValues,
            noOfPoints: onlyNumbers, // Directly update noOfPoints in the state
            error: !isValid, // Set error based on validity of the input
            helperText: onlyNumbers
                ? `Enter points between ${values.minPoints} and ${values.maxPoints}` // Show helper text based on the current min/max points
                : '', // Clear helper text if no input
            helperTextColor: isValid ? 'blue' : 'red', // Dynamic helper text color based on validation
        }));
    };

    const handleChangePoint = (field) => (event) => {
        let newValue = event.target.value;

        // For the objectiveLevel2 field, find the selected level and store the object with label and points
        if (field === 'objectiveLevel2') {
            const selectedLabel = newValue;
            const selectedItem = levelsWithPoints.find(item => item.label === selectedLabel);

            // Store the selected level object with label and points
            newValue = selectedItem || { label: '', points: 0 };
        }

        // Update the state with the new value
        setValues(prevValues => ({
            ...prevValues,
            [field]: newValue
        }));
    };

    const handleChangeMultiple = (name) => (event) => {
        const {
            target: {value},
        } = event;

        // Use the name prop to dynamically set the state
        setValues((prevValues) => ({
            ...prevValues,
            [name]: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    const getTeacherNameByIds = (teacherIds) => {

        let name = '';
        if (teachers) {
            console.log(teacherIds,teachers)
            for (const id of teacherIds) {
                const teacher = teachers.find(t => t.teacherId === id)
                if (!teacher) {
                    continue;
                }
                if (name) {
                    name += ', ' + teacher?.firstName + ' ' + teacher?.lastName
                } else {
                    name += teacher?.firstName + ' ' + teacher?.lastName
                }
            }

        }

        return name;

    }

    const getNextLevel = (actualLevel2) => {
        const currentLevelIndex = levelsWithPoints1.findIndex(level => level.label === actualLevel2);
        return levelsWithPoints1.slice(currentLevelIndex + 1);
    };

    const [showHelperText, setShowHelperText] = React.useState(false);

    const handleFocus = () => {
        setShowHelperText(true); // Show helper text when the field is focused
    };

    const handleBlur = () => {
        setShowHelperText(false); // Optionally hide helper text when the field loses focus, if desired
    };


    return (
        <Box
            component="form"
            sx={{width: '100%', minHeight: 100, minWidth: {xs: 500, sm: 300, xl: 500}}}
            noValidate
            autoComplete="off"
        >
            <Formik
                validateOnChange={true}
                initialValues={values}
                enableReinitialize={true}
                validationSchema={validationSchema}
                onSubmit={() => {
                }}
            >
                {({isSubmitting}) => (
                    <Form noValidate autoComplete="off">

                        <Div sx={{mt: 3}}>
                            <FormControl noValidate autoComplete="off">
                                <Div
                                    sx={{
                                        '& .MuiTextField-root': {
                                            mb: 2,
                                            mt: 0.5
                                        },
                                    }}
                                >

                                    <FormControl fullWidth>
                                        <TextField
                                            label={t('appointmentForm.importantInformation')}
                                            fullWidth
                                            value={values.importantInformation}
                                            onChange={handleChange('importantInformation')}
                                            multiline
                                            minRows={2} // ensures at least 2 lines
                                        />
                                    </FormControl>

                                    {/*<FormControl fullWidth>
                        <TextField
                            required
                            label={t('appointmentForm.overall')}
                            fullWidth
                            value={values.overall}
                            onChange={handleChange('overall')}
                        />
                    </FormControl>*/}

                                    {/*<FormControl fullWidth>
                        <TextField
                            required
                            label={t("appointmentForm.personality")}
                            fullWidth
                            value={values.personality}
                            onChange={handleChange('personality')}
                        />
                    </FormControl>*/}


                                    {/* Actual Level Dropdown */}
                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                        <InputLabel id="actual-level-select-label">{t("appointmentForm.actualLevel")}</InputLabel>
                                        <Select
                                            labelId="actual-level-select-label"
                                            id="actual-level-select"
                                            value={values.actualLevel2?.label || ''}
                                            label={t("appointmentForm.actualLevel")}
                                            onChange={handleLevelChange}
                                        >
                                            {levelsWithPoints1.map((level, index) => (
                                                <MenuItem key={index} value={level.label}>
                                                    {level.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    {/* Points TextField */}
                                    <FormControl fullWidth>
                                        <TextField
                                            required
                                            label="No. of Points"
                                            fullWidth
                                            value={values.noOfPoints}
                                            onChange={handleNoOfPointsChange}
                                            disabled={!values.actualLevel2?.label}
                                            onFocus={handleFocus} // Show helper text when focused
                                            onBlur={handleBlur} // Optionally hide helper text when blurred (if you want to hide it again)
                                            InputProps={{
                                                inputProps: { min: 0, inputMode: 'numeric', pattern: '[0-9]*' }, // Ensure the input is numeric.
                                            }}
                                            error={!!values.error}
                                            helperText={showHelperText ? `Enter points between ${values.minPoints} and ${values.maxPoints}` : ''} // Show helper text only when the field is focused
                                            FormHelperTextProps={{
                                                style: {
                                                    color: values.helperTextColor || 'inherit', // Use the dynamic color or default if not set.
                                                },
                                            }}
                                        />
                                    </FormControl>

                                    {/* Objective Level Dropdown */}
                                    <FormControl fullWidth sx={{ mb: 2 }}>
                                        <InputLabel id="objective-level-select-label">{t("teacher-appointment-form.title.objectiveLevel")}</InputLabel>
                                        <Select
                                            labelId="objective-level-select-label"
                                            id="objective-level-select"
                                            value={values.objectiveLevel2?.label || ''}
                                            label={t("teacher-appointment-form.title.objectiveLevel")}
                                            onChange={handleChangePoint('objectiveLevel2')}
                                        >
                                            {getNextLevel(values.actualLevel2?.label || '').map((level, index) => (
                                                <MenuItem key={index} value={level.label}>
                                                    {level.label}
                                                </MenuItem>
                                            ))}

                                        </Select>
                                    </FormControl>

                                    <FormControl fullWidth>
                                        <TextField
                                            required
                                            label={t("appointmentForm.booksRec")}
                                            fullWidth
                                            value={values.booksRecommended}
                                            onChange={handleChange('booksRecommended')}
                                        />
                                    </FormControl>

                                    <FormControl fullWidth sx={{mb: 1.5}}>
                                        <InputLabel id="demo-simple-select-label">{t("appointmentForm.teacherRec")}</InputLabel>
                                        <Select
                                            labelId="demo-multiple-checkbox-label"
                                            id="demo-multiple-checkbox"
                                            value={values.teachersRecommended}
                                            onChange={handleChangeMultiple('teachersRecommended')}
                                            multiple
                                            input={<OutlinedInput label="Teachers Recommended"/>}
                                            renderValue={(selected) => {
                                                return getTeacherNameByIds(selected);
                                            }}
                                            MenuProps={MenuProps}
                                        >
                                            {teachers && teachers.map((item, index) => (
                                                <MenuItem key={'key-teacher' + index} value={item.teacherId}>
                                                    <Checkbox
                                                        checked={values.teachersRecommended.indexOf(item.teacherId) > -1}
                                                    />
                                                    <ListItemText primary={item.firstName + ' ' + item.lastName}/>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth sx={{mb: 1.5}}>
                                        <InputLabel id="demo-simple-select-label">{t("appointmentForm.program")}</InputLabel>
                                        <Select labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={values.programFrequencyRecommended}
                                                label={t("appointmentForm.program")}
                                                onChange={handleChange('programFrequencyRecommended')}
                                        >
                                            {programFrequency.map((item, index) => (
                                                <MenuItem key={index} value={item}>
                                                    {item}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>


                                    <Stack
                                        sx={{
                                            mb: 2,
                                            width: '90%',
                                            mx: 'auto',
                                            display: 'block',
                                            position: 'relative', // Add position relative to enable absolute positioning of loader
                                        }}
                                        spacing={2}>
                                        {errMsg && <Alert severity="error">{errMsg}</Alert>}
                                    </Stack>

                                </Div>
                            </FormControl>
                        </Div>


                        {/*<Typography sx={{mt: 1, ml: 1}}
                                    variant={"h5"}>{t('student-form.workTxt')}</Typography>

                        <FormControl sx={{
                            width: {xs: '100%', sm: '100%', xl: '100%'},
                            mt: 1,
                            mb: 1,
                            ml: 1

                        }}>
                            <InputLabel id="demo-simple-select-label">{t('common.select')}</InputLabel>
                            <Select
                                sx={{width: '97%', minWidth: '50%'}}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={values?.receivedHomeWork}
                                onChange={handleChange('receivedHomeWork')}
                                label={'Select'}


                            >
                                <MenuItem value='yes'>{t("common.yesBtn")}</MenuItem>
                                <MenuItem value='no'>{t("common.noBtn")}</MenuItem>
                            </Select>
                        </FormControl>


                        <Typography sx={{mt: 1, ml: 1}}
                                    variant={"h5"}>{t("student-form.txt")}</Typography>

                        <FormControl sx={{
                            width: {xs: '100%', sm: '100%', xl: '100%'},
                            mt: 1,
                            mb: 1,
                            ml: 1

                        }}>
                            <InputLabel id="demo-simple-select-label">{t("student-form.select")}</InputLabel>
                            <Select
                                sx={{width: '97%', minWidth: '50%'}}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={values?.autoTeacherReplacement}
                                onChange={handleChange('autoTeacherReplacement')}
                                label={t("student-form.select")}


                            >
                                <MenuItem value='yes'>{t("common.yesBtn")}</MenuItem>
                                <MenuItem value='no'>{t("common.noBtn")}</MenuItem>
                            </Select>
                        </FormControl>


                        <Typography sx={{mt: 1, ml: 1}}
                                    variant={"h5"}>{t("student-form.childTxt")}</Typography>

                        <FormControl sx={{
                            width: {xs: '100%', sm: '100%', xl: '100%'},
                            mt: 1,
                            mb: 1,
                            ml: 1

                        }}>
                            <InputLabel id="demo-simple-select-label">{t("student-form.select")}</InputLabel>
                            <Select
                                required
                                sx={{width: '97%', minWidth: '50%'}}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={values?.influencer}
                                onChange={handleChange('influencer')}
                                label={t("student-form.select")}


                            >
                                <MenuItem value='yes'>{t("common.yesBtn")}</MenuItem>
                                <MenuItem value='no'>{t("common.noBtn")}</MenuItem>
                            </Select>
                        </FormControl>*/}
                    </Form>
                )}</Formik>


            <Stack sx={{width: '100%'}} spacing={2}>
                {errMsg && <Alert severity="error">{errMsg}</Alert>}
            </Stack>
            <Div sx={{display: 'flex', flexDirection: 'row', pt: 2}}>

                <Button
                    onClick={() => {
                        handleNext(3)
                    }}
                    sx={{mr: 1}}
                >
                    {(t("common.backBtn"))}
                </Button>

                <Button
                    onClick={() => {
                        hideDialog();
                    }}
                    sx={{mr: 1}}
                >
                    {(t("common.cancelBtn"))}
                </Button>
                <Div sx={{flex: '1 1 auto'}}/>

                <LoadingButton loading={isLoading} variant={"variant"} onClick={submitStep}>
                    {(t('common.finishBtn'))}
                </LoadingButton>

            </Div>
        </Box>);

};

export default Step4;
